import React from 'react';
import './FooterNav.css';
import '../../root.css';
import { Link } from 'react-router-dom';


const FooterContact = () => {
    return ( 
        <div className='FooterNav'>
            <p className='ColTitle'>Get in Touch</p>

            <ul className='FNavBtns'>
                <Link className='FNavBtn' to="/">Contact@axis.com</Link>
                <Link className='FNavBtn' to="/">+123 456 7890</Link>
                <Link className='FNavBtn' to="/">345 Realty Street <br />
                                                 Tower 5 <br />
                                                 9th floor
                </Link>
            </ul>
        </div>
     );
}
 
export default FooterContact;